import React from 'react';
import { SelectInput, SelectInputProps } from '../../atom/form';
import { OrganizationType } from 'models/organization';

export function OrganizationTypeDropdown(props: Omit<SelectInputProps<OrganizationType>, 'options'>) {
  const options = [
    { value: OrganizationType.Company, display: 'Company' },
    { value: OrganizationType.Partnership, display: 'Partnership' },
    { value: OrganizationType.SoleTrader, display: 'Sole Trader' },
  ];
  return <SelectInput options={options} {...props} />;
}
